import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import cn from 'classnames';
import { HBox } from '../../../../components/Box';
import { Button } from '../../../../components/Buttons';
import { Check, Sync, CircleTimes, EditSquare } from '../../../../components/Icon';
import { Cell, List, Row } from '../../../../components/List';
import { Modal, ModalControls } from '../../../../components/Modal';
import { getPropByName } from '../../../../utils/props';
import { selectWork } from '../../../Api/selectors';
import { fetchCompany } from '../../../Companies/actions';
import { REQUEST_COMPANY } from '../../../Companies/constants';
import { selectCompany } from '../../../Companies/selectors';
import { UserLabelById } from '../../../Users/components/UserLabelById';
import { UserSelection } from '../../../Users/components/UserSelection';
import { selectNewOrderValue, selectNewVehicleValue } from '../../selectors';
import { selectNewInvoiceValue } from '../../../Invoices/selectors';

import ButtonComponent from '../../../../containers/App/Components/Button/Button';
import styles from './FieldCompanyUser.module.css';

import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { injectIntl } from 'react-intl';
import ModalComponent from '../../../../containers/App/Components/Modal/Modal';
import { FormField } from '../../../../components/FormFields';
import { Input } from '../../../../components/Input';

const Container = styled.div`
  width: ${props => (props.formField ? '100%' : '')};
  .users {
    width: 700px;

    @media (max-width: 768px) {
      width: 100%;
    }

    .userid {
      color: #bbb;
    }
  }
`;

const STATE = {
  active: false,
  companyId: null,
  selectedUser: null,
};

/* eslint-disable react/prefer-stateless-function */
class VehicleCreateFieldCompanyUserComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  reset() {
    this.setState({ ...STATE });
  }

  static getDerivedStateFromProps(props, state) {
    let newState = { ...state };
    if (props.companyId != state.companyId) {
      props.fetch(props.companyId);
      newState.companyId = props.companyId;
    }
    return newState;
  }

  applySelection() {
    this.props.onChange(this.state.selectedUser?.id);
    this.reset();
  }

  get userId() {
    if (this.props.order) {
      return this.props.editedValue || this.props.orderValue;
    }
    return this.props.selectedCreditorId ? this.props.selectedCreditorId : this.props.value;
  }

  render() {
    return (
      <div className={cn({ [styles.large]: this.props.financialContact })}>
        <div className={styles.container}>
          {this.userId ? (
            <div className={styles.nameUser}>
              <UserLabelById order={this.props.order} user_id={this.userId} key={this.userId} />
            </div>
          ) : this.props.financialContact && !this.userId ? (
            <input disabled className="form-control" style={{ width: '100%' }} value={''} />
          ) : null}

          <OverlayTrigger
            placement="right"
            overlay={
              this.props.disabled ||
              (!this.props.companyId && !this.props.homeUsers?.length) ||
              (this.props.financialContact && this.props.includeFinancialContact !== '1') ? (
                <Tooltip className={styles.tooltip} id="tooltip-disabled">
                  {this.lbl(`add a customer`)}
                </Tooltip>
              ) : (
                <Tooltip className={styles.tooltip2} id="tooltip-disabled"></Tooltip>
              )
            }
          >
            <div className={styles.button}>
              {this.props.disabled || (!this.props.companyId && !this.props.homeUsers?.length) ? (
                ''
              ) : (
                <ButtonComponent
                  style={'ButtonSoftEdit'}
                  disabled={
                    this.props.disabled ||
                    (!this.props.companyId && !this.props.homeUsers?.length) ||
                    (this.props.financialContact && this.props.includeFinancialContact !== '1')
                  }
                  onClick={() => this.setState(prevState => ({ active: !prevState.active }))} // Toggle active state
                  id="tooltip-disabled"
                >
                  <EditSquare />
                </ButtonComponent>
              )}
            </div>
          </OverlayTrigger>
        </div>

        {this.state.active ? (
          <ModalComponent onClose={() => this.reset()}>
            {this.state.selectedUser ? (
              <>{this.state.selectedUser.name}</>
            ) : (
              <div className="users">
                <ul className={styles.list}>
                  {this.props.homeUsers?.length
                    ? this.props.homeUsers.map(this.renderUser.bind(this))
                    : this.props.company?.users.map(this.renderUser.bind(this))}
                </ul>
              </div>
            )}
          </ModalComponent>
        ) : null}
      </div>
    );
  }

  renderUser(user, index) {
    const emailAddressProp = getPropByName(user, 'email_address');
    const emailAddress = emailAddressProp || user.email_address;
    return (
      <li
        key={user.id}
        className={styles.card}
        onClick={() => {
          const userId = user.id || user.value;
          this.props.onChange(userId);
          this.reset();
        }}
      >
        {this.props.homeUsers?.length ? (
          <div className={styles.card}>
            <div className={styles.cardList}>
              <div className="userid">Id: #{user.value}</div>
              <div>{user.label}</div>
            </div>
          </div>
        ) : (
          <div className={styles.card}>
            <div className={styles.cardList}>
              <div className="userid">Id: #{user.id}</div>
              <div>Name: {getPropByName(user, 'name')}</div>
              <div>Surname: {getPropByName(user, 'surname')}</div>
              <div className={styles.emailContainer}>Email: {emailAddress}</div>
            </div>
          </div>
        )}
      </li>
    );
  }
}

VehicleCreateFieldCompanyUserComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    company: selectCompany(ownProps.companyId),
    value: selectNewVehicleValue(ownProps.type),
    orderValue: ownProps.invoicePage ? selectNewInvoiceValue(ownProps.type) : selectNewOrderValue(ownProps.type),
    work: selectWork(REQUEST_COMPANY),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch(companyId) {
      dispatch(fetchCompany(companyId));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleCreateFieldCompanyUser = compose(withConnect, withRouter)(VehicleCreateFieldCompanyUserComp);
